import React from 'react'
import { DocumentList } from './documents/DocumentDisplay';

const Financialresults = () => {
    return (
        <div>
            <main className="main">
                {/* Page Title */}
                <div className="page-title" data-aos="fade">
                    <div className="heading">
                        <div className="container">
                            <div className="row d-flex justify-content-center text-center">
                                <div className="col-lg-8">
                                    <h2 style={{ fontWeight: "bold" }}>
                                        Investors
                                        <br />
                                    </h2>
                                    <p className="mb-0">Financial Results</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <section id="policies" className="section policies">
                    <div className="container">
                        <div className="row gy-4">
                            <div
                                className="col-lg-6 order-1 order-lg-2"
                                data-aos="fade-up"
                                data-aos-delay="100"
                            >

                            </div>
                            <div
                                className="col-lg-12 order-2 order-lg-1 content"
                                data-aos="fade-up"
                                data-aos-delay="200"
                            >
                                <DocumentList category="financial_results" />
                            </div>
                        </div>
                    </div>
                </section>
                {/* /About Us Section */}
            </main>
        </div>
    )
}

export default Financialresults;
